import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand, { BrandColours } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Container = styled.div `
  --textColour: ${brand.global.white};

  display: flex;
  flex-direction: column;
  min-height: 342px;
  height: 100%;
  width: 100%;
  border-radius: 20px;
  color: var(--textColour);
  overflow: hidden;

  &[data-has-image='false'] {
    min-height: 100px;
  }

  a& {
    text-decoration: none;

    ${() => Image}, svg {
      ${transition('transform', 0.25)};
    }

    &:focus-visible,
    &:hover {
      ${() => Image}, svg {
        transform: scale(1.05);
      }
    }
  }

  &[data-variant=${BrandColours.BlueLight}],
  &[data-variant=${BrandColours.GreenLight}],
  &[data-variant=${BrandColours.OrangeLight}],
  &[data-variant=${BrandColours.PinkLight}] {
    --textColour: ${brand.global.black};
  }

  &[data-variant=${BrandColours.BlueDark}] {
    --contentColour: ${brand.primary.blue.dark};
    --imageColour: ${brand.primary.blue.light};
  }

  &[data-variant=${BrandColours.BlueLight}] {
    --contentColour: ${brand.primary.blue.light};
    --imageColour: ${brand.primary.blue.dark};
  }

  &[data-variant=${BrandColours.GreenDark}] {
    --contentColour: ${brand.secondary.green.dark};
    --imageColour: ${brand.secondary.green.light};
  }

  &[data-variant=${BrandColours.GreenLight}] {
    --contentColour: ${brand.secondary.green.light};
    --imageColour: ${brand.secondary.green.dark};
  }

  &[data-variant=${BrandColours.PurpleDark}] {
    --contentColour: ${brand.primary.purple.dark};
    --imageColour: ${brand.primary.blue.light};
  }

  &[data-variant=${BrandColours.PurpleLight}] {
    --contentColour: ${brand.primary.purple.light};
    --imageColour: ${brand.primary.blue.light};
  }

  &[data-variant=${BrandColours.OrangeMid}] {
    --contentColour: ${brand.secondary.orange.mid};
    --imageColour: ${brand.primary.blue.light};
  }

  &[data-variant=${BrandColours.OrangeDark}] {
    --contentColour: ${brand.secondary.orange.dark};
    --imageColour: ${brand.secondary.orange.light};
  }

  &[data-variant=${BrandColours.OrangeLight}] {
    --contentColour: ${brand.secondary.orange.light};
    --imageColour: ${brand.secondary.orange.dark};
  }

  &[data-variant=${BrandColours.PinkDark}] {
    --contentColour: ${brand.secondary.pink.dark};
    --imageColour: ${brand.secondary.pink.light};
  }

  &[data-variant=${BrandColours.PinkLight}] {
    --contentColour: ${brand.secondary.pink.light};
    --imageColour: ${brand.secondary.pink.dark};
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(328, 180)};

  display: grid;
  place-content: center;
  background-color: var(--imageColour);

  svg {
    width: ${fluid(104, 183)};
    aspect-ratio: 1;
  }

  @media ${from(Device.Tablet)} {
    aspect-ratio: 406 / 271;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};

  // Border radius duplicated for iOS Safari
  border-radius: 20px 20px 0 0;
`;
const ContentWrapper = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--contentColour);
  padding: ${fluid(16, 30)};
  min-height: 157px;

  ${ButtonStyles.Container} {
    --buttonHeight: ${fluid(42, 52)};

    position: relative;
    align-self: flex-end;
    margin-top: auto;
  }
`;
const Heading = styled.h3 `
  ${fonts.intro};

  font-size: ${fluid(16, 24)};
  line-height: ${fluid(18, 28)};
  margin: 0 0 ${fluid(12, 24)};
  text-transform: uppercase;

  @media ${from(Device.TabletLarge)} {
    &[data-size='md'],
    &[data-size='lg'] {
      line-height: 1.25;
    }

    &[data-size='md'] {
      font-size: ${fluid(24, 34)};
    }

    &[data-size='lg'] {
      font-size: ${fluid(28, 48)};
    }
  }
`;
const Subheading = styled.p `
  ${paragraphSmall};

  margin: 0 0 ${fluid(16, 24)};
`;
const CtaCardStyles = {
    Container,
    ImageContainer,
    Image,
    ContentWrapper,
    Heading,
    Subheading,
};
export default CtaCardStyles;
